<div class="kpi-matrix-scroll">
    <table class="data-table kpi-matrix-table" [formGroup]="matrixForm">
        <thead>
            <tr>
                <th class="kpi-matrix-th-label">{{ 'components.kpiDenominatorMatrix.typeColumn' | translate }}</th>
                @for (year of years; track trackByYear($index, year)) {
                    <th class="kpi-matrix-th-year col-number">{{ year }}</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (type of types; track trackByType($index, type)) {
                <tr>
                    <td class="kpi-matrix-td-label">
                        <span class="font-medium">{{ type.name }}</span>
                        <span class="text-xs text-color-secondary ml-1">({{ type.unit }})</span>
                    </td>
                    @for (year of years; track trackByYear($index, year)) {
                        <td class="col-number">
                            @if (type.id) {
                                <p-inputNumber
                                    [formControlName]="controlKey(type.id, year)"
                                    [min]="0"
                                    [maxFractionDigits]="2"
                                    [minFractionDigits]="0"
                                    mode="decimal"
                                    placeholder="—"
                                    [fluid]="true"
                                    class="kpi-matrix-field"
                                    inputStyleClass="kpi-matrix-input"
                                    [attr.aria-label]="type.name + ' ' + year"></p-inputNumber>
                            }
                        </td>
                    }
                </tr>
            }
        </tbody>
    </table>
</div>
